const r=async()=>{let a=navigator?.userAgentData?.platform||navigator?.platform;if("userAgentData"in navigator){const t=await navigator.userAgentData.getHighEntropyValues(["platform"]);t?.platform&&(a=t.platform)}return a};export{r as getPlatformName};
//# sourceMappingURL=getPlatformName.js.map
